import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import DOMPurify from 'dompurify';
import { Utilities } from 'app/shared/helpers/utilities';

@Component({
  selector: 'html-widget-settings',
  templateUrl: './html-widget-settings.component.html',
  styleUrls: ['./html-widget-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HtmlWidgetSettingsComponent implements OnInit {

  form: UntypedFormGroup;
  settings: any;
  hasChanged = false;
  value: string;
  newValue: string;

  constructor(
    public dialogRef: MatDialogRef<HtmlWidgetSettingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder) {
      this.settings = data || {};
     }

  ngOnInit() {
    this.form = this.fb.group({
      showInWidget: [this.settings.showInWidget],
    });

    this.value = DOMPurify.sanitize(this.settings.value);

    Utilities.patchCheckboxAria();
  }

  onValueChange(value) {
    this.newValue = value;
  }

  save(){
    this.data = undefined;
    this.settings.value = DOMPurify.sanitize(this.newValue || this.value);
    this.settings.showInWidget = this.form.controls['showInWidget'].value;
    this.dialogRef.close({
      data: this.settings,
    });
  }
}
